export class AnnouncerResponse {
	public status: String;
	public error: Array<String>;

	constructor() {
		
	}
}